import { createRouter, createWebHashHistory, Router, RouteRecordRaw } from "vue-router"
import beforeEach from "@/router/beforeEach"
import afterEach from "@/router/afterEach"
import { renderRoutes as MobileRenderRoute } from "@/router/mobileRender"
import { renderRoutes as DesktopRenderRoute } from "@/router/desktopRender"
import { QueryInItInfoResponse } from "@/types/queryInitInfo"

const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )

const getEventTypeFromUrl = () => {
  const currentUrl = window.location.href
  const url = new URL(currentUrl)

  return url.searchParams.get("eventType") || ""
}

const removeEventTypeFromUrl = () => {
  const url = new URL(window.location.href)
  url.searchParams.delete("eventType")
  window.history.replaceState({}, document.title, url.toString())
}

const initializeRouter = (router: Router, routes: RouteRecordRaw[]) => {
  routes.forEach(route => {
    router.addRoute(route)
  })
}

const renderRoutes = (
  router: Router,
  { optional }: { optional: QueryInItInfoResponse }
) => {
  const eventType = getEventTypeFromUrl()

  const routes = isMobile()
    ? MobileRenderRoute({ ...optional, eventType })
    : DesktopRenderRoute({ ...optional })

  initializeRouter(router, routes)

  router.isReady().then(() => {
    if (eventType) removeEventTypeFromUrl()
  })
}

const router = createRouter({
  history: createWebHashHistory("/"),
  routes: []
})

router.beforeEach(beforeEach)
router.afterEach(afterEach)

export { renderRoutes }
export default router
